import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { FieldsetBox, LegendStyled } from '../styling/StyledComponents';

export default function OutputChoice(props) {
  const { userParams, setUserParams, choices } = props;

  const handleChange = (event) => {
    const value = event.target.value;
    setUserParams({ ...userParams, output:value })
  }

  return (
    <FieldsetBox component="fieldset" sx={{ mt: 1 }}>
      <LegendStyled>Output option</LegendStyled>
      <RadioGroup
        row
        value={userParams.output}
        onChange={handleChange}
      >
        { choices.map((opt) => (
            <FormControlLabel
                key={opt}
                value={opt}
                control={<Radio size="small" />}
                label={opt.toUpperCase()}
            />
        ))}
      </RadioGroup>
    </FieldsetBox>
  )
}